module.exports = __webpack_public_path__ + "static/img/solution_item1.81bbb42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/solution_item1.png
// module id = Z4Gp
// module chunks = 34